/* eslint-disable no-param-reassign */

// Anything canvas-shaped: node-canvas Canvas, HTMLCanvasElement, OffscreenCanvas.
type DisposableCanvas = {
	width: number;
	height: number;
};

// Releases a canvas's backing store immediately instead of at GC. Matters in
// WebKit, which caps total canvas memory per page and keeps detached canvases
// alive until collected; past the cap, new canvases silently draw nothing.
function disposeCanvas(canvas: DisposableCanvas) {
	canvas.width = 0;
	canvas.height = 0;
}

function disposeCanvasContext({
	canvas,
}: {
	readonly canvas: DisposableCanvas;
}) {
	disposeCanvas(canvas);
}

export { disposeCanvasContext, disposeCanvas };
